import { getRouteApi } from '@tanstack/react-router';
import type { PermissionsResponseDTO } from '@tempo-io/id-dto';
import type { Permission } from '@tempo-io/permissions';

const routeApi = getRouteApi('/(app)');

export const usePermissions = () => {
  const routeContext = routeApi.useRouteContext();
  return routeContext.permissions;
};

export const PERMISSION_DENIED = 'Permission Denied';

export class PermissionDeniedError extends Error {
  readonly permission: Permission;

  constructor(permission: Permission) {
    super(PERMISSION_DENIED);
    this.name = 'PermissionDeniedError';
    this.permission = permission;
  }
}

export const requirePermission =
  (permission: Permission) =>
  async ({ context }: { context: { permissions: Partial<PermissionsResponseDTO> } }) => {
    if (!context.permissions[permission]) {
      throw new PermissionDeniedError(permission);
    }
  };
